import { Injectable, Inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../http/auth.service';
import { IEnvironmentConfig } from "../../models/environmentConfig";
import { AppConfig } from "../../app.config";
import { Features } from '../../models/features';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    private readonly useUniversalLogin: boolean = false;

    constructor(
        private router: Router,
        public authService: AuthService,
        private appConfig: AppConfig,
    ) {
        this.useUniversalLogin = this.appConfig.getSection(Features.UNIVERSALLOGIN)?.enabled ?? false;
        console.log('AuthGuard constructed');
    }

    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const isLoggedIn = this.authService.isLoggedIn();

        if (isLoggedIn) {
            return true;
        }
        if (this.useUniversalLogin) {
            const returnUrl = encodeURIComponent(state.url);
            window.location.href = `${this.envSettings.loginFeUrl}/login?return_url=${returnUrl}`;
        } else {
            // Traditional login redirect
            await this.router.navigate(['/auth/signin']);
        }

        return false;
    }
}